import i18n from '@fiverr/i18n/singleton';
import type { BusinessLogicCallbackArgs, EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';
import { shouldDisplayCard } from '../utils/shouldDisplayCard';

export const DownloadAppCardImpl = {
    getJobInfo: async (args) => ({
        shouldDisplayJob: await shouldDisplayCard(args),
        dismissInfo: {
            isDismissible: true,
            jtbdTTL: 45,
        },
        headerText: i18n.t('jobs_tbd.download_app.header_text', { $scope: args.context.locale }),
        jobPages: [
            {
                title: i18n.t('jobs_tbd.download_app.title', { $scope: args.context.locale }),
                subtitle: i18n.t('jobs_tbd.download_app.subtitle', { $scope: args.context.locale }),
                iconUrl:
                    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b159ff8f36a2d642cc49bee730d410d0-1744103818184/Download.jpg',
                ctaText: i18n.t('jobs_tbd.download_app.cta', { $scope: args.context.locale }),
            },
        ],
        clickAction: {
            type: 'modal',
        },
    }),
    cardCallbacks: {
        customActionCallback: (args?: BusinessLogicCallbackArgs) => {
            args?.hanlders.openModal();
        },
    },
} satisfies EagerJobsTbdSdk;
